import { FC, Ref } from 'react';

import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { selectFirstPurchasable, selectIsFullPricePayment } from '@telialt/utils/src/eshopSelectors';

import { ProductOfferPricesView } from './ProductOfferPricesView';

type Props = {
    ref: Ref<HTMLElement>;
};

export const ProductOfferPrices: FC<Props> = ({ ref }) => {
    const { cart } = useCartQuery();

    const productEntry = selectFirstPurchasable(cart);
    const showMonthlyPrices = !selectIsFullPricePayment(cart);

    if (!productEntry) {
        return null;
    }

    const monthlyWithoutDiscount = productEntry.monthlyPriceWithoutDiscount;
    const totalWithoutDiscount = productEntry.totalPriceWithoutDiscount;
    const monthlyWithDiscount =
        productEntry.monthlyPriceWithDiscount?.value !== monthlyWithoutDiscount?.value
            ? productEntry.monthlyPriceWithDiscount
            : undefined;
    const totalWithDiscount =
        productEntry.totalFullPriceWithDiscount?.value !== totalWithoutDiscount?.value
            ? productEntry.totalFullPriceWithDiscount
            : undefined;
    const monthlyWithPlan =
        productEntry.monthlyPriceWithPlan?.value !== monthlyWithoutDiscount?.value
            ? productEntry.monthlyPriceWithPlan
            : undefined;
    const totalWithPlan =
        productEntry.totalPriceWithPlan?.value !== totalWithoutDiscount?.value
            ? productEntry.totalPriceWithPlan
            : undefined;
    const monthlyWith5gPlan =
        productEntry.monthlyPriceWith5gPlan?.value !== monthlyWithoutDiscount?.value
            ? productEntry.monthlyPriceWith5gPlan
            : undefined;
    const totalWith5gPlan =
        productEntry.totalPriceWith5gPlan?.value !== totalWithoutDiscount?.value
            ? productEntry.totalPriceWith5gPlan
            : undefined;

    const prices =
        !showMonthlyPrices || monthlyWithoutDiscount
            ? {
                  monthlyWith5gPlan,
                  totalWith5gPlan,
                  monthlyWithPlan,
                  totalWithPlan,
                  monthlyWithDiscount,
                  totalWithDiscount,
                  monthlyWithoutDiscount,
                  totalWithoutDiscount,
              }
            : {
                  totalWithDiscount: productEntry.totalFullPriceWithDiscount,
                  monthlyWithDiscount: productEntry.monthlyPrice,
                  totalWithoutDiscount: productEntry.product?.standardPrice,
                  monthlyWithoutDiscount: productEntry.monthlyPrice,
              };

    return <ProductOfferPricesView ref={ref} showMonthlyPrices={showMonthlyPrices} prices={prices} />;
};
